import { render } from "./PerformanceBackroomDetail.vue?vue&type=template&id=3cac662a&scoped=true"
import script from "./PerformanceBackroomDetail.vue?vue&type=script&lang=js"
export * from "./PerformanceBackroomDetail.vue?vue&type=script&lang=js"

import "./PerformanceBackroomDetail.vue?vue&type=style&index=0&id=3cac662a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cac662a"]])

export default __exports__